import { useAuth } from '../../../contexts/AuthContext';
import { LoadingState } from '../../ui/loading-state';
import Setup from '../Setup';

interface TrialGuardProps {
  children: React.ReactNode;
}

const TrialGuard = ({ children }: TrialGuardProps) => {
  const { user, loading } = useAuth();

  // Wait for auth to load
  if (loading) {
    return <LoadingState />;
  }

  // Check if user has trial = true in user_metadata
  const isTrialUser = user?.user_metadata?.trial === true || user?.user_metadata?.needs_setup === true;

  if (isTrialUser) {
    // If user is a trial user, show the Setup component
    return <Setup />;
  }

  // If user is not a trial user, pass through to children
  return <>{children}</>;
};

export default TrialGuard;
